import React, { useEffect, useState } from "react";
import { useAuthentication } from "../../../Authentication/context/authentication.context";
import { Spinner } from "../../../../shared";
import "./visitor-dashboard.page.scss";

export const VisitorDashboard = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuthentication();

  useEffect(() => {
    fetch("/api/inventories/visitor/items", {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch items");
        }
        return res.json();
      })
      .then((data) => {
        setItems(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching visitor items:", err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="visitor-dashboard">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="visitor-dashboard">
        <div className="error-state">
          <p>Greška pri učitavanju predmeta: {error}</p>
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="visitor-dashboard">
        <h1>Predmeti dodeljeni meni</h1>
        {user && <p className="user-email">Prijavljeni ste kao: {user.email}</p>}
        <div className="empty-state">
          <p>Trenutno vam nisu direktno dodeljeni predmeti.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="visitor-dashboard">
      <h1>Predmeti dodeljeni meni</h1>
      {user && <p className="user-email">Prijavljeni ste kao: {user.email}</p>}

      <div className="items-table-container">
        <table className="items-table">
          <thead>
            <tr>
              <th>Inventarski broj</th>
              <th>Naziv</th>
              <th>Kompanija</th>
              <th>Lokacija</th>
              <th>Dodeljeno</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>{item.itemId}</td>
                <td>{item.label}</td>
                <td>{item.company?.label || "-"}</td>
                <td>{item.location?.name || "-"}</td>
                <td>{item.assignedTo || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="items-count">
        Ukupno predmeta: {items.length}
      </div>
    </div>
  );
};
